import axios from 'axios';
import Qs from 'qs';
import isUndefined from 'lodash/isUndefined';
import lodashGet from 'lodash/get';

export default class AbstractService {
	constructor(baseURL, options) {
		if (isUndefined(baseURL)) throw new Error('baseURL is required');

		this.baseURL = baseURL;
		this.apiVersion = lodashGet(options, 'apiVersion', 6);
		this.authToken = options.authTokenCallback;
	}

	get(params) {
		return this.request({
			...params,
			method : 'GET',
		});
	}

	post(params) {
		return this.request({
			...params,
			method : 'POST',
		});
	}

	put(params) {
		return this.request({
			...params,
			method : 'PUT',
		});
	}

	del(params) {
		return this.request({
			...params,
			method : 'DELETE',
		});
	}

	request({
		endpoint,
		method = 'GET',
		data,
		queryParams,
		headers,
		responseType,
		getCancelToken,
		allowAnonymous,
	}) {
		return this.abstractRequest({
			endpoint,
			method,
			data,
			queryParams,
			headers,
			responseType,
			getCancelToken,
			allowAnonymous,
		});
	}

	async abstractRequest({
		method,
		data,
		endpoint,
		queryParams,
		responseType,
		getCancelToken,
		baseURL = this.baseURL,
		headers = {},
		withCredentials = false,
		allowAnonymous = false,
		paramsSerializer = (params) => (Qs.stringify(params, { arrayFormat : 'repeat' })),
	}) {
		let requestHeaders = { ...headers };

		const useToken = baseURL === this.baseURL;
		const { adb2cEnabled } = window;

		if (!(allowAnonymous && adb2cEnabled) && useToken) {
			const accessToken = await this.authToken();
			requestHeaders = { Accept : 'application/vnd.rollkall.v6+json', Authorization : `Bearer ${accessToken}`, ...requestHeaders };
		}

		return axios({
			baseURL,
			method,
			data,
			withCredentials,
			responseType,
			paramsSerializer,
			headers     : requestHeaders,
			url         : endpoint,
			params      : queryParams,
			cancelToken : !isUndefined(getCancelToken) ? new axios.CancelToken(getCancelToken) : undefined,
		});
	}
}
